





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import DepositOverdraftSettingsEdit from '@/components/Products/Forms/Deposit/DepositOverdraftSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'DepositOverdraftSettingsEditDialog', components: { DepositOverdraftSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean, oldVal: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
        }
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editDepositOverdraftSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
